import { Controller } from "@hotwired/stimulus"
import { getMetaValue } from "helpers"

export default class extends Controller {
  static targets = [ "errorMessage", "paymentIntentClientSecret", "paymentIntentId", "submitButton" ]

  connect() {
    if (this.hasPaymentIntentClientSecretTarget) {
      this.disableSubmitButton()
      this.handleCardAction(this.paymentIntentClientSecretTarget.value)
    }
  }

  handleCardAction(clientSecret) {
    const stripe = Stripe(getMetaValue("stripe-key"), {
      stripeAccount: getMetaValue("stripe-account")
    })

    stripe.handleCardAction(clientSecret).then(result => {
      if (result.error) {
        this.showErrorMessage(result.error.message)
        this.enableSubmitButtton()
      } else {
        this.paymentIntentIdTarget.value = result.paymentIntent.id
        this.submitForm()
      }
    })
  }

  disableSubmitButton() {
    this.submitButtonText = this.submitButtonTarget.textContent
    this.submitButtonTarget.textContent = this.submitButtonTarget.dataset.turboSubmitsWith
    this.submitButtonTarget.disabled = true
  }

  enableSubmitButtton() {
    this.submitButtonTarget.textContent = this.submitButtonText
    this.submitButtonTarget.disabled = false
  }

  showErrorMessage(message) {
    const paragraph = document.createElement("p")
    paragraph.textContent = message

    this.errorMessageTarget.classList.remove("hidden")
    this.errorMessageTarget.replaceChildren(paragraph)
  }

  submitForm() {
    this.enableSubmitButtton()
    this.element.requestSubmit(this.submitButtonTarget)
  }
}
